import { render, staticRenderFns } from "./boxes.vue?vue&type=template&id=796cffa2&"
import script from "./boxes.vue?vue&type=script&lang=js&"
export * from "./boxes.vue?vue&type=script&lang=js&"
import style0 from "./boxes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports